export type DashboardWelcomeBuildMode = 'code' | 'agent' | 'both';
export type DashboardQuickstartTab = 'curl' | 'javascript' | 'python' | 'mcp';

export const DASHBOARD_WELCOME_CONSUMED_KEY = 'dashboard-welcome-consumed';
export const DASHBOARD_WELCOME_BUILD_MODE_KEY = 'dashboard-welcome-build-mode';

export function getDashboardWelcomeConsumedKey(organizationId: string | null | undefined): string {
    return organizationId ? `${DASHBOARD_WELCOME_CONSUMED_KEY}:${organizationId}` : DASHBOARD_WELCOME_CONSUMED_KEY;
}

export function getDashboardWelcomeBuildModeKey(organizationId: string | null | undefined): string {
    return organizationId ? `${DASHBOARD_WELCOME_BUILD_MODE_KEY}:${organizationId}` : DASHBOARD_WELCOME_BUILD_MODE_KEY;
}

export function parseWelcomeFlag(value: unknown): boolean {
    // TanStack Router JSON-parses search params (`?welcome=1` arrives as the
    // number 1) and re-validates its own validated output (boolean), so the
    // parser must accept all three shapes and stay idempotent.
    if (typeof value === 'boolean') {
        return value;
    }

    if (typeof value === 'number') {
        return value === 1;
    }

    if (typeof value !== 'string') {
        return false;
    }

    return value.trim() === '1';
}

export function parseBuildMode(value: unknown): DashboardWelcomeBuildMode | null {
    if (typeof value !== 'string') {
        return null;
    }

    const normalized = value.trim().toLowerCase();

    if (normalized === 'code' || normalized === 'agent' || normalized === 'both') {
        return normalized;
    }

    return null;
}

export function getDefaultQuickstartTab(buildMode: DashboardWelcomeBuildMode): DashboardQuickstartTab {
    return buildMode === 'agent' ? 'mcp' : 'javascript';
}
